import { darken, lighten } from 'polished';
import styled from 'styled-components';

interface IContainerSmallButtonIcon {
  size: number;
  value: boolean;
}

export const ContainerSmallButtonIcon = styled.div<IContainerSmallButtonIcon>`
  height: ${({ size }) => size}px;
  border-radius: 25px;
  min-width: ${({ size }) => size}px;
  background-color: ${lighten(0.12, '#0f4f4f')};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s all;
  transform: ${({ value }) => (value ? 'rotate(-180deg)' : 'rotate(0deg)')};
  &:hover {
    background-color: ${darken(0.05, '#0f4f4f')};
  }
  @media (max-width: 650px) {
    display: none;
  }

  img {
    width: 25px;
    height: 25px;
  }
`;
